export default __webpack_public_path__ + "static/kleine-eismanufaktur_3-2-b0b7cf84555d7853f85b5c27bdbea007.jpg";